import React from 'react';
import Event from '@/model/Event';
import { SelectCustom } from '@/components';
import { FormData, FormErrors, OnChangeFormInput } from '@/hooks/useForm';
import { Col, Form, FormGroup, Row } from 'reactstrap';

export interface StateProps {
  eventChild: Event[];
  formData: FormData;
  formErrors: FormErrors;
}

export interface DispatchProps {
  onChangeFormInput: OnChangeFormInput;
}

// eslint-disable-next-line no-shadow
export enum FormRadioInput {
  eventClone = 'eventClone',
}

type Pros = StateProps & DispatchProps;

export const CloneProductScreen: React.FC<Pros> = ({
  eventChild,
  formData,
  formErrors,
  onChangeFormInput,
}): JSX.Element => {
  const options = eventChild.map(event => ({
    value: event.id,
    label: event.name,
  }));

  return (
    <Form
      noValidate={true}
      onSubmit={(e): void => {
        e.preventDefault();
      }}
    >
      <Row>
        <Col md={8}>
          <FormGroup className="mb-2">
            <SelectCustom
              name="eventClone"
              label="Selecione o Evento para clonar"
              placeholder="..."
              value={formData[FormRadioInput.eventClone]}
              onChange={e => {
                onChangeFormInput(FormRadioInput.eventClone)(e?.value as string);
              }}
              error={formErrors.chargeSetupId && formErrors.chargeSetupId[0]}
              options={options}
            />
          </FormGroup>
        </Col>
      </Row>
    </Form>
  );
};
